import PoolsApi from '../api/pools'
import { addInfoNotification, addErrorNotification } from './notifications'
import { HIDE_MODAL } from './modal'
import { isEmpty } from '../helpers/string'

export const SYNC_PARTNER_RESTAURANT_DETAILS = 'SYNC_PARTNER_RESTAURANT_DETAILS'

export const syncPartnerRestaurantsDetails = (partnerId, partnerSubscriptionId) => {
  return dispatch => {
    dispatch({
      type: HIDE_MODAL
    })

    if (isEmpty(partnerId) || isEmpty(partnerSubscriptionId)) {
      dispatch(addErrorNotification('Error syncing partner restaurants details', 'Ensure pool assgined to real Partner Subscription'))
      return
    }

    PoolsApi.SyncPartnerRestaurantsDetails(partnerId, partnerSubscriptionId)
      .then(() => {
        dispatch(addInfoNotification('Partner restaurants details were synced'))
      })
      .catch(error => {
        dispatch(addErrorNotification('Error syncing partner restaurants details', error.message))
        console.log('Catch fetch error: ', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/syncPartnerRestaurantsDetails.js